var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"value":_vm.itemRevision,"view":_vm.current_view,"mode":_vm.embeded_ip ? '' : 'preview'},on:{"update:view":function($event){_vm.current_view=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }